import { Controller } from "@hotwired/stimulus"

// Selection for the bulk form on the tie-out screen. The row checkboxes already belong to
// that form through their `form` attribute, so with JS off the form submits whatever is
// ticked; this only keeps the count honest and adds the shortcuts.
export default class extends Controller {
  static targets = ["row", "count", "submit"]

  connect() {
    this.changed()
  }

  changed() {
    const selected = this.rowTargets.filter(box => box.checked).length
    this.countTarget.textContent = selected
    this.submitTarget.disabled = selected === 0
  }

  // Every row the gate is still waiting on, wherever it sits in the ledger.
  selectBlocking() {
    this.rowTargets.forEach(box => {
      box.checked = box.closest("tr").dataset.blocking === "true"
    })
    this.changed()
  }

  clear() {
    this.rowTargets.forEach(box => { box.checked = false })
    this.changed()
  }

  // The header checkbox of one activity's table takes or releases that table's rows.
  toggleGroup(event) {
    const rows = event.target.closest("table").querySelectorAll("[data-bulk-edit-target='row']")
    rows.forEach(box => { box.checked = event.target.checked })
    this.changed()
  }
}
